import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const Ribbon = () => {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div className="relative border-y border-white/10 bg-[#0A0A0B] py-6 md:py-8" data-testid="ribbon">
      <Marquee speed={30} gradient={false} autoFill>
        <span className="font-serif-display text-3xl md:text-5xl text-zinc-200/90 mx-6 tracking-tight">
          {text}
        </span>
      </Marquee>
    </div>
  );
};
